import React, {useRef, useState, useMemo} from 'react';
import {useTranslation} from 'react-i18next';
import {StyleSheet, View, Image} from 'react-native';
import {useDispatch, useSelector} from 'react-redux';
import BottomSheet from 'src/components/bottom-sheet';
import {getApp} from '../../../actions/app';
import {CustomText} from '../../../components/text/Text';
import {isWeb} from '../../../constants';
import {selecetApptype} from '../../../selectors/App';
import {styles as ConstantStyles, defaultTheme} from '../../../theme';
import SVG from '../../svg';
import {selectrootsheettype} from '../../../selectors/SheetSelector';
import {showSheet} from '../../../actions/SheetActions';
import {useLocation} from '../../Router';
import parkingImage from 'src/assets/images/parkingLogo.png';
import farBike from 'src/assets/images/farBike.png';
import farMotor from 'src/assets/images/farMotor.png';
import farBikeGray from 'src/assets/images/farBikeGray.png';
import farMotorGray from 'src/assets/images/farMotorGray.png';

const ParkingBottomSheet = ({}) => {
  const {selectedParking} = useSelector(state => selecetApptype(state));
  const {sheetId, sheetProps} = useSelector(state =>
    selectrootsheettype(state),
  );

  const bottomSheetRef = useRef(null);
  const {t} = useTranslation();
  const dispatch = useDispatch();
  const location = useLocation();

  const closeBottomSheet = () => {
    dispatch(
      showSheet({
        sheetId: '',
        sheetProps: undefined,
      }),
    );
    if (isWeb) {
      bottomSheetRef?.current?.snapTo(() => 0);
    } else {
      bottomSheetRef.current?.close();
      setTimeout(() => {
        dispatch(
          showSheet({
            sheetId: '',
          }),
        );
      }, 500);
    }
  };

  if (sheetId == '') return <></>;
  return (
    <BottomSheet
      ref={bottomSheetRef}
      snapPoints={isWeb ? ({minHeight}) => [1, minHeight] : [195]}
      isTransparent={location?.pathname === '/main/map'}
      onSpringEnd={
        isWeb
          ? () => {
              if (bottomSheetRef?.current?.height < 2) {
                dispatch(
                  showSheet({
                    sheetId: '',
                  }),
                );
              }
            }
          : undefined
      }
      defaultSnap={isWeb ? 195 : undefined}
      open={sheetProps?.visible}
      isScrollView={isWeb ? undefined : false}
      handleIndicatorStyle={
        !isWeb ? {backgroundColor: 'transparent'} : undefined
      }
      onClose={closeBottomSheet}>
      <View style={styles.sheetContainer}>
        <View style={styles.titleRow}>
          <CustomText
            size={18}
            font="400"
            mr={8}
            color={defaultTheme.colors.grey8}>
            {sheetProps?.name}
          </CustomText>
          <Image source={parkingImage} style={styles.parkingImage} />
        </View>
        <View style={[styles.titleRow, {marginVertical: 3}]}>
          <CustomText
            size={13}
            font="400"
            mr={8}
            color={defaultTheme.colors.grey8}>
            {t('WorkTime')} :{' '}
            {(() => {
              const opening = sheetProps?.opening_time;

              const closing = sheetProps?.closing_time;

              // چک همه مقادیر ناخواسته
              const isInvalid =
                !opening ||
                !closing ||
                opening === 'null' ||
                closing === 'null' ||
                opening === 'undefined' ||
                closing === 'undefined';

              if (isInvalid) {
                // اگر شبانه روزی هست (Time === 2) نمایش بده، در غیر این صورت boarding
                if (sheetProps?.Time === 2) return t('24_hours'); // شبانه روزی
                return t('bording'); // پیش‌فرض
              }

              // همه چیز اوکیه → نمایش بازه ساعت
              return `${opening
                ?.split(':')
                ?.slice(0, 2)
                .join(':')} الی ${closing?.split(':')?.slice(0, 2).join(':')}`;
            })()}
          </CustomText>
          <SVG name={'stopWatchGray'} width={18} height={18} />
        </View>
        {sheetProps?.address && (
          <View style={styles.descRow}>
            <CustomText
              size={13}
              mr={6}
              font={'400'}
              color={defaultTheme.colors.grey6}>
              {t('address')} : {sheetProps?.address}
            </CustomText>
            <SVG name={'location'} width={15} height={15} />
          </View>
        )}
        <View style={styles.capacityContainer}>
          <View style={styles.capacityContainerVehicel}>
            <View style={styles.capacityContainerBike}>
              <CustomText
                mr={4}
                color={defaultTheme.colors.grey8}
                size={14}
                font={'400'}>
                {sheetProps?.bicycle_remain_capacity}
              </CustomText>
              <Image
                source={
                  sheetProps?.bicycle_remain_capacity === 0
                    ? farBikeGray
                    : farBike
                }
                style={
                  sheetProps?.bicycle_remain_capacity === 0
                    ? styles.VehicelImage2
                    : styles.VehicelImage
                }
              />
            </View>
            <View style={styles.capacityContainerBike}>
              <CustomText
                mr={4}
                color={defaultTheme.colors.grey8}
                size={14}
                font={'400'}>
                {sheetProps?.bike_remain_capacity}
              </CustomText>
              <Image
                source={
                  sheetProps?.bike_remain_capacity === 0
                    ? farMotorGray
                    : farMotor
                }
                style={
                  sheetProps?.bike_remain_capacity === 0
                    ? styles.VehicelImage2
                    : styles.VehicelImage
                }
              />
            </View>
          </View>
          <View style={styles.capacityContainerIcon}>
            <CustomText
              size={14}
              mr={6}
              font={'400'}
              color={defaultTheme.colors.grey6}>
              موجودی
            </CustomText>
            <SVG name={'cube'} width={14.5} height={14.5} />
          </View>
        </View>
        <View style={styles.capacityContainer}>
          <View style={styles.capacityContainerVehicel}>
            <View style={styles.capacityContainerBike}>
              <CustomText
                mr={4}
                color={defaultTheme.colors.grey8}
                size={14}
                font={'400'}>
                {sheetProps?.bicycle_remain_capacity}
              </CustomText>
              <Image
                source={
                  sheetProps?.bicycle_remain_capacity === 0
                    ? farBikeGray
                    : farBike
                }
                style={
                  sheetProps?.bicycle_remain_capacity === 0
                    ? styles.VehicelImage2
                    : styles.VehicelImage
                }
              />
            </View>
            <View style={styles.capacityContainerBike}>
              <CustomText
                mr={4}
                color={defaultTheme.colors.grey8}
                size={14}
                font={'400'}>
                {sheetProps?.bike_remain_capacity}
              </CustomText>
              <Image
                source={
                  sheetProps?.bike_remain_capacity === 0
                    ? farMotorGray
                    : farMotor
                }
                style={
                  sheetProps?.bike_remain_capacity === 0
                    ? styles.VehicelImage2
                    : styles.VehicelImage
                }
              />
            </View>
          </View>
          <View style={styles.capacityContainerIcon}>
            <CustomText
              size={14}
              mr={6}
              font={'400'}
              color={defaultTheme.colors.grey6}>
              ظرفیت خالی
            </CustomText>
            <SVG name={'cube'} width={14.5} height={14.5} />
          </View>
        </View>
      </View>
    </BottomSheet>
  );
};

export default ParkingBottomSheet;

const styles = StyleSheet.create({
  parkingImage: {
    width: 20,
    height: 20,
    resizeMode: 'contain',
  },
  VehicelImage: {
    width: 60,
    height: 50,
    resizeMode: 'contain',
  },
  VehicelImage2: {
    width: 30,
    height: 25,
    resizeMode: 'contain',
  },
  title: {
    fontSize: 18,
    fontFamily: ConstantStyles.font.IranYekan[400],
    color: defaultTheme.colors.grey8,
  },
  capacityContainer: {
    flexDirection: 'row',
    justifyContent: 'flex-end',

    width: '100%',
  },
  capacityContainerIcon: {
    width: '30%',
    flexDirection: 'row',
    justifyContent: 'flex-end',
    alignItems: 'center',
  },
  capacityContainerVehicel: {
    width: '60%',
    flexDirection: 'row',
    justifyContent: 'flex-end',
    alignItems: 'center',
  },
  capacityContainerBike: {
    width: '50%',
    flexDirection: 'row',
    justifyContent: 'flex-end',
    alignItems: 'center',
  },
  desc: {
    fontFamily: ConstantStyles.font.IranYekan[400],
    color: defaultTheme.colors.grey6,
    fontSize: 14,
  },
  descRow: {
    flexDirection: 'row',
    alignItems: 'center',
    margintop: 3,
    paddingLeft: 4,
  },
  titleRow: {
    flexDirection: 'row',
    alignItems: 'center',
    marginVertical: 3,
  },
  sheetContainer: {
    width: '100%',
    alignItems: 'flex-end',
    top: isWeb ? -10 : -22,
    paddingHorizontal: 13.5,
    paddingVertical: 13.5,
  },
  titleRow‌Item: {
    width: '50%',
    alignItems: 'center',
    flexDirection: 'row',
    justifyContent: 'flex-end',
  },
});
